import PropTypes from 'prop-types';

/** For local SPA app development. */
export const DevApp = PropTypes.shape({ //eslint-disable-line
  /** A loadApp function used for development. Returns a promise that resolves with the SPA app component. */
  loader: PropTypes.func.isRequired,
  /** An appPath used for development. e.g. /mq/ */
  path: PropTypes.string.isRequired,
});
